/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
export const KeyListResult = {
    type: {
        name: "Composite",
        className: "KeyListResult",
        modelProperties: {
            items: {
                serializedName: "items",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "Key"
                        }
                    }
                }
            },
            nextLink: {
                serializedName: "@nextLink",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const Key = {
    type: {
        name: "Composite",
        className: "Key",
        modelProperties: {
            name: {
                serializedName: "name",
                readOnly: true,
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const ErrorModel = {
    type: {
        name: "Composite",
        className: "ErrorModel",
        modelProperties: {
            type: {
                serializedName: "type",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "title",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "name",
                type: {
                    name: "String"
                }
            },
            detail: {
                serializedName: "detail",
                type: {
                    name: "String"
                }
            },
            status: {
                serializedName: "status",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export const KeyValueListResult = {
    type: {
        name: "Composite",
        className: "KeyValueListResult",
        modelProperties: {
            items: {
                serializedName: "items",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "KeyValue"
                        }
                    }
                }
            },
            nextLink: {
                serializedName: "@nextLink",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const KeyValue = {
    type: {
        name: "Composite",
        className: "KeyValue",
        modelProperties: {
            key: {
                serializedName: "key",
                required: true,
                type: {
                    name: "String"
                }
            },
            label: {
                serializedName: "label",
                type: {
                    name: "String"
                }
            },
            contentType: {
                serializedName: "content_type",
                type: {
                    name: "String"
                }
            },
            value: {
                serializedName: "value",
                type: {
                    name: "String"
                }
            },
            lastModified: {
                serializedName: "last_modified",
                type: {
                    name: "DateTime"
                }
            },
            tags: {
                serializedName: "tags",
                type: {
                    name: "Dictionary",
                    value: { type: { name: "String" } }
                }
            },
            locked: {
                serializedName: "locked",
                type: {
                    name: "Boolean"
                }
            },
            etag: {
                serializedName: "etag",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const LabelListResult = {
    type: {
        name: "Composite",
        className: "LabelListResult",
        modelProperties: {
            items: {
                serializedName: "items",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "Label"
                        }
                    }
                }
            },
            nextLink: {
                serializedName: "@nextLink",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const Label = {
    type: {
        name: "Composite",
        className: "Label",
        modelProperties: {
            name: {
                serializedName: "name",
                readOnly: true,
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationGetKeysHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationGetKeysHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationCheckKeysHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationCheckKeysHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationGetKeyValuesHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationGetKeyValuesHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationCheckKeyValuesHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationCheckKeyValuesHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationGetKeyValueHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationGetKeyValueHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            },
            eTag: {
                serializedName: "etag",
                type: {
                    name: "String"
                }
            },
            lastModified: {
                serializedName: "last-modified",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationPutKeyValueHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationPutKeyValueHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            },
            eTag: {
                serializedName: "etag",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationDeleteKeyValueHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationDeleteKeyValueHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            },
            eTag: {
                serializedName: "etag",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationCheckKeyValueHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationCheckKeyValueHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            },
            eTag: {
                serializedName: "etag",
                type: {
                    name: "String"
                }
            },
            lastModified: {
                serializedName: "last-modified",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationGetLabelsHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationGetLabelsHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationCheckLabelsHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationCheckLabelsHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationPutLockHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationPutLockHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            },
            eTag: {
                serializedName: "etag",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationDeleteLockHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationDeleteLockHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            },
            eTag: {
                serializedName: "etag",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationGetRevisionsHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationGetRevisionsHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationCheckRevisionsHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationCheckRevisionsHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationGetKeysNextHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationGetKeysNextHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationGetKeyValuesNextHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationGetKeyValuesNextHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationGetLabelsNextHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationGetLabelsNextHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export const AppConfigurationGetRevisionsNextHeaders = {
    type: {
        name: "Composite",
        className: "AppConfigurationGetRevisionsNextHeaders",
        modelProperties: {
            syncToken: {
                serializedName: "sync-token",
                type: {
                    name: "String"
                }
            }
        }
    }
};
//# sourceMappingURL=mappers.js.map